import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Historique — horloge avec flèche retour duotone */
export const HistoryIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Cadran menthe */}
      <circle cx="12" cy="12" r="8" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      <circle cx="12" cy="12" r="8" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Aiguilles (heures + minutes pointant ~10h) */}
      <path d="M12 7.5V12l-2.5 2" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      {/* Flèche retour à gauche du cadran */}
      <path
        d="M2 8l3 1.5L6.5 6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <path
        d="M5 9.5C5.5 6 8.5 3.5 12 3.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
HistoryIcon.displayName = "HistoryIcon";
